import React, { type ReactNode } from 'react';

interface DropdownMenuHeadingProps {
    children: ReactNode;
}

const DropdownMenuHeading = (props: DropdownMenuHeadingProps) => {
    return <h6 className="yat-dashboard-top-bar-user-navigation__heading">{props.children}</h6>;
};

export default DropdownMenuHeading;
